export const SESSION_END_REASON_KEY = 'hrm_session_end_reason';

export type SessionEndReason = 'session-ended' | 'force-logout';

let endingSession = false;

export function markSessionEnded(reason: SessionEndReason): void {
  try {
    sessionStorage.setItem(SESSION_END_REASON_KEY, reason);
  } catch {
    /* ignore quota / private mode */
  }
}

export function consumeSessionEndReason(): SessionEndReason | null {
  try {
    const value = sessionStorage.getItem(SESSION_END_REASON_KEY);
    if (value) sessionStorage.removeItem(SESSION_END_REASON_KEY);
    if (value === 'force-logout' || value === 'session-ended') return value;
  } catch {
    /* ignore */
  }
  return null;
}

export function resetSessionEnding(): void {
  endingSession = false;
}

/**
 * Clear local auth and return the UI to login.
 * Used when refresh fails after 401 or 403 SESSION_STALE.
 */
export function hardLogout(reason: SessionEndReason = 'session-ended'): void {
  if (endingSession) return;
  endingSession = true;
  markSessionEnded(reason);
  void import('@/stores/auth-store').then(({ useAuthStore }) => {
    useAuthStore.getState().logout();
  });
}

export function readSessionEndNotice(): string | null {
  let reason: SessionEndReason | null = consumeSessionEndReason();
  try {
    const params = new URLSearchParams(window.location.search);
    const queryReason = params.get('reason');
    if (queryReason === 'force-logout' || queryReason === 'session-ended') {
      reason = queryReason;
      params.delete('reason');
      const qs = params.toString();
      window.history.replaceState(
        {},
        '',
        `${window.location.pathname}${qs ? `?${qs}` : ''}${window.location.hash}`,
      );
    }
  } catch {
    /* ignore */
  }
  if (reason === 'force-logout') {
    return 'Your session was ended by an administrator. Please sign in again.';
  }
  if (reason === 'session-ended') {
    return 'Your access was changed or your session expired. Please sign in again.';
  }
  return null;
}
